<template>
  <div class="call-center" v-if="getData">
    <div class="call-center__banner">
      <div class="content">
        <div class="call-center__banner-text">
          <div class="call-center__banner-title">
            <span style="color: #830051">Исследуйте</span> новое <br />с
            колл-центром
          </div>
          <div class="call-center__banner-subtitle">
            Колл-центр – это эффективный способ быстро и точно получить
            информацию о препаратах компании Астразенека.
          </div>
          <div class="call-center__banner-description">
            Разделение на специализированные проекты помогает сосредоточиться на
            интересах и потребностях каждой врачебной специальности. Опытные
            операторы предоставят актуальные данные о лекарственных препаратах,
            клинических исследованиях и рекомендациях, стараясь сделать каждый
            звонок максимально полезным и информативным.
          </div>
          <img
            class="d-xl-none"
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/call-center/1.png 2x`"
          />
          <div class="call-center__banner-buttons" id="projects">
            <div
              @click="setCheckedCenters()"
              v-if="!checkedSlugs.includes('-')"
              class="call-center__banner-button button button_pink"
            >
              Присоединиться к колл-центру
            </div>
            <a
              href="#projects"
              class="call-center__banner-button button button_empty-pink"
            >
              Узнать больше о проектах
              <svg
                class="ml-2"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 5.5V19.5M12.5 19.5L18.5 13.5M12.5 19.5L6.5 13.5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </div>
          <img
            class="d-none d-xl-block"
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/call-center/1.png 2x`"
          />
        </div>
      </div>
    </div>
    <div class="call-center__map-block">
      <div class="content">
        <div class="call-center__map">
          <div class="call-center__map-title">
            <span style="color: #830051">Карта</span> <br />проектов
          </div>
          <div class="call-center__map-tip d-xl-none">
            <div class="call-center__map-tip-icon">
              <svg
                width="34"
                height="33"
                viewBox="0 0 34 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="33" height="33" rx="16.5" fill="#F4E6EF" />
                <path
                  d="M16.2295 24.3334C15.8406 24.3334 15.4761 24.25 15.1358 24.0834C14.7955 23.9167 14.5073 23.6806 14.2712 23.375L10.0837 18.0625C9.97258 17.9375 9.92397 17.7882 9.93786 17.6146C9.95175 17.441 10.0143 17.2987 10.1254 17.1875C10.4031 16.8959 10.7365 16.7223 11.1254 16.6667C11.5143 16.6112 11.8754 16.6875 12.2087 16.8959L13.7504 17.8334V11C13.7504 10.7639 13.8302 10.566 13.9899 10.4063C14.1497 10.2466 14.3476 10.1667 14.5837 10.1667C14.8198 10.1667 15.0212 10.2466 15.1879 10.4063C15.3545 10.566 15.4379 10.7639 15.4379 11V19.3334C15.4379 19.6528 15.2955 19.8924 15.0108 20.0521C14.7261 20.2118 14.4448 20.2084 14.167 20.0417L13.417 19.5834L15.5837 22.3542C15.667 22.4514 15.7643 22.5278 15.8754 22.5834C15.9865 22.6389 16.1045 22.6667 16.2295 22.6667H20.8337C21.292 22.6667 21.6844 22.5035 22.0108 22.1771C22.3372 21.8507 22.5004 21.4584 22.5004 21V17.6667C22.5004 17.4306 22.4205 17.2327 22.2608 17.073C22.1011 16.9132 21.9031 16.8334 21.667 16.8334H17.9379C17.7018 16.8334 17.5038 16.7535 17.3441 16.5938C17.1844 16.4341 17.1045 16.2362 17.1045 16C17.1045 15.7639 17.1844 15.566 17.3441 15.4063C17.5038 15.2466 17.7018 15.1667 17.9379 15.1667H21.667C22.3615 15.1667 22.9518 15.4098 23.4379 15.8959C23.924 16.382 24.167 16.9723 24.167 17.6667V21C24.167 21.9167 23.8406 22.7014 23.1879 23.3542C22.5351 24.007 21.7504 24.3334 20.8337 24.3334H16.2295ZM17.4795 13.5C17.2434 13.5 17.0455 13.4202 16.8858 13.2605C16.7261 13.1007 16.6462 12.9028 16.6462 12.6667C16.6462 12.6389 16.6809 12.5 16.7504 12.25C16.8615 12.0556 16.9448 11.8577 17.0004 11.6563C17.0559 11.4549 17.0837 11.2362 17.0837 11C17.0837 10.3056 16.8406 9.71532 16.3545 9.22921C15.8684 8.7431 15.2781 8.50004 14.5837 8.50004C13.8893 8.50004 13.299 8.7431 12.8129 9.22921C12.3268 9.71532 12.0837 10.3056 12.0837 11C12.0837 11.2362 12.1115 11.4549 12.167 11.6563C12.2226 11.8577 12.3059 12.0556 12.417 12.25C12.4587 12.3195 12.4865 12.3889 12.5004 12.4584C12.5143 12.5278 12.5212 12.5973 12.5212 12.6667C12.5212 12.9028 12.4448 13.1007 12.292 13.2605C12.1393 13.4202 11.9448 13.5 11.7087 13.5C11.5559 13.5 11.4136 13.4584 11.2816 13.375C11.1497 13.2917 11.049 13.1875 10.9795 13.0625C10.799 12.757 10.6601 12.4306 10.5629 12.0834C10.4656 11.7362 10.417 11.375 10.417 11C10.417 9.84726 10.8233 8.86462 11.6358 8.05212C12.4483 7.23962 13.4309 6.83337 14.5837 6.83337C15.7365 6.83337 16.7191 7.23962 17.5316 8.05212C18.3441 8.86462 18.7504 9.84726 18.7504 11C18.7504 11.375 18.7018 11.7362 18.6045 12.0834C18.5073 12.4306 18.3684 12.757 18.1879 13.0625C18.1184 13.1875 18.0212 13.2917 17.8962 13.375C17.7712 13.4584 17.6323 13.5 17.4795 13.5Z"
                  fill="#830051"
                />
              </svg>
            </div>
            <div class="call-center__map-tip-text">
              Нажмите на иконку, чтобы увидеть <br />подробности о проекте
            </div>
          </div>
          <div class="call-center__map-items">
            <img
              class="call-center__map-line d-none d-xl-block"
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/call-center/line.png 2x`"
            />
            <img
              class="call-center__map-line d-xl-none"
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/call-center/line_mob.png 2x`"
            />
            <div
              class="call-center__map-item"
              :class="[
                `call-center__map-item_${item.position}`,
                `call-center__map-item-${ind + 1}`,
              ]"
              v-for="(item, ind) in projects.filter((p) => p.icon)"
              :key="ind"
              @click="toggleModal(true, ind)"
            >
              <div class="call-center__map-item-icon">
                <img :srcset="`${item.icon} 2x`" />
              </div>
              <div class="call-center__map-item-text">
                <div
                  class="call-center__map-item-checked"
                  v-if="checkedSlugs.includes(item.slug)"
                >
                  <svg
                    class="mr-2"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="24"
                      height="24"
                      rx="12"
                      fill="#7AC628"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M6 12L10.2426 16.2426L18.7275 7.75732"
                      stroke="#7AC628"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Заявка отправлена
                </div>
                <div class="call-center__map-item-title">
                  {{ item.title }}
                </div>
                <div class="call-center__map-item-area">
                  {{ item.therapeutic_area }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="call-center__slider" v-if="slides">
      <div class="content">
        <div class="call-center__slider-title">Библиотека подкастов</div>
        <div class="call-center__slider-description">
          Раздел "Библиотека подкастов" предлагает удобное хранилище
          аудиозаписей, где вы можете прослушивать полезные сведения о
          лекарственных препаратах и актуальных медицинских темах в любое время.
          Это отличный способ расширить свои знания и улучшить практику без
          спешки в удобное для вас время
        </div>
        <div class="call-center__slider-container">
          <swiper class="call-center__slider-slider" v-bind="swiperSettings">
            <swiper-slide v-for="(slide, ind) in slides" :key="ind">
              <Material
                :item="slide"
                :page="'PodcastDetail'"
                :hideFavorites="true"
              />
            </swiper-slide>
          </swiper>
          <div class="call-center__slider-arrows">
            <div
              class="call-center__slider-arrow call-center__slider-arrow_left"
            >
              <svg
                width="15"
                height="27"
                viewBox="0 0 15 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 1.5L2 13.5L14 25.5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <div
              class="call-center__slider-arrow call-center__slider-arrow_right"
            >
              <svg
                width="15"
                height="27"
                viewBox="0 0 15 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L13 13.5L1 25.5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="call-center__modal" v-if="!isNaN(parseInt(modalNumber))">
      <div class="call-center__modal-overlay" @click="toggleModal(false)"></div>
      <div class="call-center__modal-body">
        <div class="call-center__modal-close" @click="toggleModal(false)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 3.00005L3 21M21.0001 21L3 2.99995"
              stroke="#A1A5A7"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="call-center__modal-content">
          <div class="call-center__modal-head">
            <div
              class="call-center__modal-icon"
              v-if="projects[modalNumber].icon"
            >
              <img :srcset="`${projects[modalNumber].icon} 2x`" />
            </div>
            <div class="call-center__modal-title">
              {{ projects[modalNumber].title }}
            </div>
          </div>
          <div
            class="call-center__modal-text"
            v-if="!checkedSlugs.includes(projects[modalNumber].slug)"
            v-html="projects[modalNumber].text"
          ></div>
          <div class="call-center__modal-text" v-else>
            Спасибо за Ваш интерес к проекту! Наш оператор свяжется с Вами в
            ближайшее время
          </div>
          <div
            v-if="!checkedSlugs.includes(projects[modalNumber].slug)"
            @click="
              setCheckedCenters({ direction: projects[modalNumber].title })
            "
            class="call-center__modal-button button button_pink"
          >
            Присоединиться к колл-центру
          </div>
          <div
            class="call-center__modal-approval"
            v-if="!checkedSlugs.includes(projects[modalNumber].slug)"
            v-html="projects[modalNumber].approval"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";
import "swiper/swiper-bundle.css";
import { Navigation } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import { mapActions } from "vuex";
import Material from "@/components/pageComponents/Material.vue";
SwiperCore.use([Navigation]);
export default {
  name: "CallCenter",
  components: {
    Swiper,
    SwiperSlide,
    Material,
  },
  data: () => ({
    checkedSlugs: [],
    getData: false,
    modalNumber: null,
    swiperSettings: {
      slidesPerView: 3,
      loop: true,
      navigation: {
        nextEl: ".call-center__slider-arrow_right",
        prevEl: ".call-center__slider-arrow_left",
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1220: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    },
    slides: null,
  }),
  computed: {
    projects() {
      return [
        {
          slug: "Умная терапия",
          title: "Умная терапия",
          therapeutic_area: "Терапевты и ВОП",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon1.png`,
          position: "left",
          text: `
            Проект «Умная терапия» создан для врачей-терапевтов, которые хотят оставаться на передовой современной медицины. Здесь вы найдете ценные практические рекомендации и актуальную информацию о лечении различных заболеваний. Гастроэнтерология, кардиология, респираторные и хронические патологии — все в одном месте.
            <br>
            <br>
            Экспертные данные можно быстро и удобно получить через колл-центр. Они помогут оперативно решать сложные клинические задачи, экономя ваше драгоценное время. А больше о продуктах компании АстраЗенека можно узнать на <a href="https://az-most.ru/medication/nexium" target="_blank">сайте</a>.
            <br>
            <br>
            Умная терапия не просто обучает — она вдохновляет на новые профессиональные высоты и открывает двери к инновационным методам лечения.
            <br>
            <br>
            Присоединяйтесь к проекту и читайте больше подробностей о продукции компании АстраЗенека на <a href="https://az-most.ru/medication/betalok?access=13a1dea8138f04438571e2f7c3d65487#mechanism" target="_blank">сайте</a>. Пусть ваши пациенты получают эффективное лечение, а вы — уверенность в своих решениях. Этот проект станет вашим незаменимым помощником в ежедневной практике.
          `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "Актуальная кардиология",
          title: "Актуальная кардиология",
          therapeutic_area: "Кардиологи",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon2.png`,
          position: "right",
          text: `
            Проект «Актуальная кардиология» помогает врачам быть на шаг впереди в лечении сердечно-сосудистых заболеваний.
            <br>
            <br>
            Здесь вы получите актуальную информацию о диагностике и ведении пациентов с артериальной гипертензией, ИБС, хронической сердечной недостаточностью и нарушениями ритма.
            <br>
            <br>
            Изучите ключевые рекомендации Европейского общества кардиологов, стратегии повышения приверженности пациентов терапии и алгоритмы снижения сердечно-сосудистых рисков.
            <br>
            <br>
            Актуальная кардиология — ваш источник знаний для спасения сердец.
            <br>
            <br>
            Дополнительную информацию о продуктах компании АстраЗенека вы можете 
            найти на <a href="https://crestor-galaxy.az-most.ru/#diagnostic" target="_blank">сайте</a>
          `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "НефроПро",
          title: "НефроПро",
          therapeutic_area: "Нефрологи",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon3.png`,
          position: "right",
          text: `
            Проект «НефроПро» — это образовательный проект для врачей, посвященный ключевым вопросам диагностики и лечения хронической болезни почек.
            <br>
            <br>
            Вы получите актуальную информацию о новых рекомендациях KDIGO 2024, алгоритмах скрининга, методах коррекции остаточного риска и основных линиях терапии почечных заболеваний.
            <br>
            <br>
            Материалы помогут интегрировать передовые подходы в вашу практику.
        `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "О маленьких пациентах с БА",
          title: "О маленьких пациентах с бронхиальной астмой",
          therapeutic_area: "Пульмоспециалисты детские и педиатры ",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon4.png`,
          position: "right",
          text: `
            Проект «О маленьких пациентах с бронхиальной астмой» создан для врачей, которые занимаются диагностикой и лечением бронхиальной астмы у детей. Платформа предлагает практические рекомендации, которые помогают своевременно начинать терапию, предотвращая необратимые изменения в легочной ткани и улучшая прогноз для маленьких пациентов.
            <br>
            <br>
            Здесь вы найдете современные подходы к диагностике и лечению, включая актуальные обновления Федеральных клинических рекомендаций. Отдельное внимание уделено особенностям бронхообструктивного синдрома у детей на фоне ОРВИ, что позволяет эффективно предотвращать осложнения.
            <br>
            <br>
            Также освещены темы, связанные с преодолением барьеров в лечении: стереотипы, опасения родителей и пути повышения приверженности к терапии.
        `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "Вам решать, как им дышать",
          title: "Вам решать, как им дышать",
          therapeutic_area: "Пульмоспециалисты взрослые",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon5.png`,
          position: "right",
          text: `
            Проект «Вам решать, как им дышать» создан для врачей, которые хотят уверенно решать задачи диагностики и лечения заболеваний дыхательной системы. Здесь собраны ключевые подходы к контролю хронических респираторных заболеваний, включая ХОБЛ, и рекомендации, которые помогут улучшить жизнь пациентов.
            <br>
            <br>
            Проект предлагает готовые решения для оценки эффективности терапии и выбора оптимальных методов лечения даже в самых сложных случаях. Это ваш доступ 
            к инструментам, которые сделают лечение ваших пациентов успешным 
            и предсказуемым.
            <br>
            <br>
            Присоединяйтесь к проекту, чтобы расширить свои профессиональные горизонты 
            и внедрить передовые подходы в повседневную практику.
        `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "#ДАПАможет",
          title: "#ДАПАможет",
          therapeutic_area: "Эндокринологи",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon6.png`,
          position: "left",
          text: `
            Проект «#ДАПАможет» — это платформа для врачей, которая предлагает готовые решения для лечения сахарного диабета 2 типа и управления сердечно-сосудистыми рисками. Здесь собраны практические рекомендации по комбинированной терапии, которая упрощает контроль диабета, повышает приверженность пациентов и улучшает результаты лечения.
            <br>
            <br>
            Платформа помогает разобраться в подходах к снижению сердечно-сосудистых рисков, включая работу с пациентами с высоким уровнем угрозы. Отдельное внимание уделяется вопросам безопасности, эффективности терапии и преодолению финансовых барьеров.
            <br>
            <br>
            #ДАПАможет — это удобный доступ к знаниям и инструментам, которые делают лечение проще и эффективнее. Присоединяйтесь, чтобы ваши пациенты получали лучшее качество жизни.
            <br>
            <br>
            Больше о продуктах компании АстраЗенека можно узнать на <a href="https://crestor-galaxy.az-most.ru/#diagnostic" target="_blank">сайте</a>
        `,
          approval:
           "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "Привычка жить лучше",
          title: "Привычка жить лучше",
          therapeutic_area: "Гастроэнтерологи",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon1.png`,
          position: "right",
          text: `
            Проект «Привычка жить лучше» создан для врачей, стремящихся глубже понять потребности пациентов и улучшить качество их жизни.
            <br>
            <br>
            Узнайте, как составить детальный портрет пациента, чтобы учитывать не только клинические данные, но и личные особенности, которые влияют на выбор и приверженность медикаментозной терапии.
            <br>
            <br>
            Погрузитесь в ключевые факторы, определяющие успешность лечения, включая психологические аспекты, социальное окружение и индивидуальные предпочтения.
            <br>
            <br>
            Исследуйте подходы к созданию доверительных отношений с пациентами, чтобы сформировать у них осознанный подход к здоровью и лечению.
            <br>
            <br>
            Привычка жить лучше — это проект, который помогает врачам не только назначать терапию, но и менять жизнь пациентов к лучшему, формируя у них устойчивые привычки заботы о здоровье.
            <br>
            <br>
            Больше о продуктах компании АстраЗенека можно узнать на <a href="https://crestor-galaxy.az-most.ru/#diagnostic" target="_blank">сайте</a>
        `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "Жизненно важное",
          title: "Жизненно важное",
          therapeutic_area: "Онкологи и гастроэнтерологи",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon8.png`,
          position: "right",
          text: `
            Проект «Жизненно важное» — образовательная инициатива для врачей, направленная на внедрение современных подходов в лечении онкологических заболеваний. Программа охватывает ключевые темы для специалистов разных направлений, помогая улучшать результаты терапии и обеспечивать безопасность пациентов.
            <br>
            <br>
            Основное внимание уделено новым возможностям в терапии рака желудка и подходам к лечению мНМРЛ с мутацией в гене KRAS. Также обсуждаются диагностические стратегии для гастроэнтерологов, направленные на выявление пациентов с высоким риском рака желудка.
            <br>
            <br>
            Для хирургов и радиотерапевтов проект подчеркивает значимость адъювантной терапии на ранних стадиях рака легкого и предлагает методы минимизации нежелательных явлений при проведении терапии.
            <br>
            <br>
            Платформа «ПРОРАК» предоставляет доступ к специализированным ресурсам и помогает врачам принимать обоснованные решения для повышения эффективности лечения. Жизненно важное — это источник знаний, которые спасают жизни.     
        `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "Найти и не упустить",
          title: "Найти и не упустить",
          therapeutic_area: "Педиатры, онкологи и неврологи детские",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon9.png`,
          position: "right",
          text: `
            Проект «Найти и не упустить» создан для врачей, которые хотят лучше понимать генетические заболевания и использовать эффективные подходы к их диагностике и лечению. На платформе вы найдете полезную информацию о нейрофиброматозе 1 типа (НФ1): его природе, симптомах, этапах прогрессирования и методах раннего выявления.
            <br>
            <br>
            Здесь собраны практические рекомендации и стратегии терапии, которые помогают минимизировать осложнения и улучшить качество жизни пациентов. Особое внимание уделяется индивидуальному подходу к лечению на каждой стадии заболевания.
            <br>
            <br>
            Найти и не упустить — это ваш источник знаний для внедрения передовых методов диагностики и лечения в практику, чтобы обеспечить пациентам с НФ1 шанс на полноценную жизнь.
            <br>
            <br>
            Присоединяйтесь к проекту, чтобы быть в авангарде медицинских инноваций!
        `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          slug: "Академия СКВ",
          title: "Академия СКВ",
          therapeutic_area: "Ревматологи",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/call-center/icon10.png`,
          position: "right",
          text: `
            Проект «Академия СКВ» — это платформа для ревматологов, которая помогает решать сложные клинические задачи и углублять знания о лечении системной красной волчанки и сопутствующих состояний.
            <br>
            <br>
            На платформе представлены клинические случаи с практическими примерами диагностики и терапии СКВ на основе видеообзоров от ведущих экспертов. Реальные примеры помогают лучше понять особенности заболевания и найти оптимальные пути лечения.
            <br>
            <br>
            Особое внимание уделено новым подходам к терапии. Также вы найдете рекомендации по управлению болью у пациентов с СКВ.
            <br>
            <br>
            Академия СКВ предоставляет врачам доступ к экспертным данным и практическим рекомендациям, которые помогают улучшать качество лечения пациентов.
            <br>
            <br>
            Больше о продуктах компании АстраЗенека можно узнать на <a href="https://az-most.ru/medication/nexium" target="_blank">сайте</a>
        `,
          approval:
            "Номер одобрения: RU-23736 Дата одобрения: 28.01.2025 Дата истечения: 27.01.2027",
        },
        {
          title: `Ваша заявка отправлена!`,
          slug: "-",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchPodcastWatchLater", "fetchPodcastFavorite"]),
    toggleModal(state, ind) {
      this.$set(this, "modalNumber", !isNaN(parseInt(ind)) ? ind : null);
      bus.$emit("scrollLock", state);
    },
    getPodcasts() {
      this.$axios({
        method: "GET",
        url: `/api/library/podcast/`,
      })
        .then(async (response) => {
          const result = response.data;
          this.$set(this, "slides", result);
          return true;
        })
        .catch((error) => {
          return false;
        });
    },
    getCheckedCenters() {
      this.$axios({
        url: `/api/call-center-bid/`,
        method: "GET",
      })
        .then((res) => {
          this.$set(this, "getData", true);
          if (res && res.data) {
            res.data
              .map((d) => d.direction)
              .forEach((d) => {
                this.checkedSlugs.push(d);
              });
          }
        })
        .catch((error) => {});
    },
    setCheckedCenters(body) {
      this.$axios({
        url: `/api/call-center-bid/`,
        method: "POST",
        data: body,
      })
        .then((res) => {
          this.checkedSlugs.push(res.data.direction);
          if (!body) {
            this.toggleModal(true, this.projects.length - 1);
          }
        })
        .catch((error) => {});
    },
  },
  created() {
    this.getPodcasts();
    this.getCheckedCenters();
  },
};
</script>

<style lang="scss" scoped>
.call-center {
  overflow-x: hidden;
  &__banner {
    overflow: hidden;
    padding: 48px 0;
    &-text {
      position: relative;
      width: 60%;
      @media screen and (max-width: 1220px) {
        width: 100%;
      }
    }

    & img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 80%;
      z-index: -1;
      @media screen and (max-width: 1220px) {
        position: static;
        width: 100%;
        transform: none;
      }
    }

    &-title {
      margin-bottom: 28px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 42px;
      line-height: 120%;
      color: #3c4242;
      @media screen and (max-width: 767px) {
        font-size: 32px;
      }
    }

    &-subtitle {
      margin-bottom: 24px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 120%;
      color: #000000;

      @media screen and (max-width: 767px) {
        font-size: 16px;
      }
    }

    &-description {
      margin-bottom: 48px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 120%;
      color: #000000;

      @media screen and (max-width: 767px) {
        margin-bottom: 0px;
        font-size: 14px;
      }
    }

    &-buttons {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      column-gap: 24px;
      @media screen and (max-width: 1220px) {
        flex-direction: column;
        row-gap: 24px;
      }
    }

    &-button {
      padding: 16px 18px;
      font-size: 16px;
    }
  }

  &__map {
    padding: 62px 0 0;
    border-radius: 28px;
    overflow: hidden;
    background-image: url("https://storage.yandexcloud.net/" + $VUE_APP_BACKET_NAME + "/media/content/public/assets/img/call-center/2.jpg");
    background-repeat: repeat-y;
    background-size: 100% auto;
    background-position: top;
    @media screen and (max-width: 767px) {
      padding: 40px 0 0;
      border-radius: 0;
    }

    &-block {
      & .content {
        @media screen and (max-width: 767px) {
          padding: 0;
        }
      }
    }

    &-title {
      margin-bottom: 56px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 42px;
      line-height: 110%;
      text-align: center;
      color: #3c4242;
      @media screen and (max-width: 767px) {
        font-size: 32px;
        margin-bottom: 16px;
      }
    }

    &-tip {
      margin-bottom: 30px;

      &-icon {
        margin: 0 auto;
        width: fit-content;
      }

      &-text {
        margin-top: 16px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        text-align: center;
        color: #3c4242;
      }
    }

    &-items {
      padding: 0 30px 90px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      @media screen and (max-width: 1220px) {
        align-items: flex-start;
      }
      @media screen and (max-width: 767px) {
        padding: 0 16px 45px;
      }
    }

    &-line {
      position: absolute;
      top: 85px;
      left: 50%;
      transform: translateX(-50%);
      height: 2714px;
      @media screen and (max-width: 1220px) {
        left: 70px;
        transform: none;
      }

      @media screen and (max-width: 767px) {
        left: 30px;
        top: 50px;
        height: 1527px;
      }
    }

    &-item {
      position: relative;
      z-index: 2;
      cursor: pointer;

      &_left {
        & .call-center__map-item-text {
          right: calc(100% + 30px);
          @media screen and (max-width: 1220px) {
            right: auto;
            left: calc(100% + 30px);
          }
          @media screen and (max-width: 767px) {
            left: calc(100% + 15px);
          }
          &::before {
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-left: 10px solid #fff;
            left: 100%;
            @media screen and (max-width: 1220px) {
              border-left: 0;
              border-right: 10px solid #fff;
              left: auto;
              right: 100%;
            }
          }
        }
      }

      &_right {
        & .call-center__map-item-text {
          left: calc(100% + 30px);
          @media screen and (max-width: 767px) {
            left: calc(100% + 15px);
          }
          &::before {
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-right: 10px solid #fff;
            right: 100%;
          }
        }
      }

      &-checked {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 12px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
        color: #3c4242;
        white-space: nowrap;
         @media screen and (max-width: 767px) {
          font-size: 12px;
         }
      }

      &-text {
        width: fit-content;
        padding: 24px;
        border-radius: 19px;
        background-color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        @media screen and (max-width: 767px) {
          padding: 12px 16px;
          max-width: 208px;
          width: max-content;
        }

        &::before {
          width: 0;
          height: 0;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          content: "";
          display: block;
        }
      }

      &-title {
        margin-bottom: 16px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 23px;
        line-height: 120%;
        color: #3c4242;
        @media screen and (max-width: 767px) {
          font-size: 16px;
        }
      }

      &-area {
        width: fit-content;
        white-space: nowrap;
        padding: 2px 10px;
        background-color: #f7e9f4;
        border-radius: 99px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
        color: #3c4242;
        @media screen and (max-width: 767px) {
          font-size: 12px;
          white-space: normal;
          border-radius: 13px;
          padding: 8px;
        }
      }

      &-icon {
        width: 120px;
        & > img {
          width: 100%;
          transition: .5s;
        }
        @media screen and (max-width: 1220px) {
          width: 150px;
        }

        @media screen and (max-width: 767px) {
          width: 100px;
        }
      }

      @media screen and (min-width: 1220px) {
        &:hover {
          & .call-center__map-item-icon {
            & img {
              transform: scale(1.1);
            }
          }
        }
      }

      @media screen and (max-width: 1220px) {
        &:not(:last-child) {
          margin-bottom: 45px !important;
        }
        margin-top: 0 !important;
        margin-left: 0 !important;
      }

      &-1 {
        @media screen and (max-width: 1220px) {
          margin-left: 30px !important;
        }
      }
      &-2 {
        margin-top: 150px;
        margin-left: -140px;
        @media screen and (max-width: 1220px) {
          margin-left: 80px !important;
        }
        @media screen and (max-width: 767px) {
          margin-left: 20px !important;
        }
      }
      &-3 {
        margin-top: 40px;
        margin-left: -660px;
        @media screen and (max-width: 767px) {
          margin-left: 0 !important;
        }
      }
      &-4 {
        margin-top: 70px;
        margin-left: 0;
        @media screen and (max-width: 767px) {
          margin-left: 10px !important;
        }
      }
      &-5 {
        margin-top: 100px;
        margin-left: -60px;
        @media screen and (max-width: 1220px) {
          margin-left: 70px !important;
        }
        @media screen and (max-width: 767px) {
          margin-left: -10px !important;
        }
      }
      &-6 {
        margin-top: 100px;
        margin-left: 90px;
      }
      &-7 {
        margin-top: 100px;
        margin-left: -640px;
        @media screen and (max-width: 1220px) {
          margin-left: 10px !important;
        }
        @media screen and (max-width: 767px) {
          margin-left: -10px !important;
        }
      }
      &-8 {
        margin-top: 80px;
        margin-left: -230px;
        @media screen and (max-width: 1220px) {
          margin-left: 60px !important;
        }
        @media screen and (max-width: 767px) {
          margin-left: 10px !important;
        }
      }
      &-9 {
        margin-top: 100px;
        margin-left: -400px;
      }
      &-10 {
        margin-top: 70px;
        margin-left: -120px;
      }
    }
  }

  &__modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
      display: none;
    }
    @media screen and (max-width: 767px) {
      padding: 16px 0;
    }

    &-overlay {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
    }

    &-body {
      padding: 48px 32px;
      position: relative;
      z-index: 3;
      max-width: 50vw;
      margin: auto;
      background-color: #fff;
      border-radius: 32px;
      @media screen and (max-width: 1220px) {
        max-width: 80vw;
      }

      @media screen and (max-width: 767px) {
        max-width: 90vw;
        padding: 32px 16px 24px;
      }
    }

    &-close {
      position: absolute;
      top: 48px;
      right: 32px;
      cursor: pointer;
      @media screen and (max-width: 767px) {
        top: 15px;
        right: 15px;
      }
    }

    &-head {
      margin-bottom: 24px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    &-icon {
      flex-shrink: 0;
      margin-right: 24px;
      width: 100px;

      & img {
        width: 100%;
      }

      @media screen and (max-width: 767px) {
        width: 80px;
      }
    }
    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 32px;
      line-height: 120%;
      color: #232c32;
      @media screen and (max-width: 767px) {
        font-size: 20px;
      }
    }

    &-text {
      padding-bottom: 24px;
      margin-bottom: 24px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      color: #323c42;
      border-bottom: 1px solid #d9d9d9;
      @media screen and (max-width: 767px) {
        font-size: 14px;
      }
    }

    &-button {
      padding: 17px 24px;
      margin: 0 auto;
    }

    &-approval {
      margin-top: 24px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #b2b4b4;
    }
  }

  &__slider {
    padding: 60px 0;
    @media screen and (max-width: 767px) {
      padding: 40px 0;
    }

    &-container {
      position: relative;
    }

    &-title {
      margin-bottom: 30px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 42px;
      line-height: 120%;
      color: #3c4242;
      @media screen and (max-width: 767px) {
        font-size: 32px;
      }
    }

    &-description {
      margin-bottom: 32px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      color: #3c4242;
      @media screen and (max-width: 767px) {
        font-size: 16px;
      }
    }

    &-arrows {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(100% + 224px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      user-select: none;

      @media screen and (max-width: 1220px) {
        justify-content: center;
        column-gap: 30px;
        position: static;
        margin-top: 24px;
        transform: none;
        width: 100%;
      }
    }

    &-arrow {
      width: 72px;
      height: 72px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #f2f2f2;
      color: #830051;
      user-select: none;
      @media screen and (max-width: 767px) {
        width: 40px;
        height: 40px;

        & > svg {
          width: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.call-center {
  & .swiper-wrapper {
    align-items: stretch;
  }

  & .swiper-slide {
    height: auto;
  }

  & .material {
    height: 100%;
  }

  &__modal {
    &-text {
      & a {
        color: #830051;
      }
    }
  }
}
</style>